import { RemoteUploadBanner } from 'data/usecases';
import { makeApiUrlBanner } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUploadBanner = (): RemoteUploadBanner => {
  return new RemoteUploadBanner(makeApiUrlBanner(), makeAxiosHttpClient());
};
